<template>
    <div id="body">
        <div id="portfolio-feature-wrap">
            <div id="portfolio-feature">
                <div id="frame" class="frame frame-story">
                    <Header :mobile="platform.mobile" @sub-navigation-navigate="$emit('sub-navigation-navigate', $event)"/>
                    <div class="content-secondary">
                        <div id="story">
                            <h1 class="m-align-c">My Story</h1>
                            <div id="story-intro-divider" v-if="platform.mobile"></div>

                            <!-- Story sections segmented at start year -->
                            <Timespan
                                v-for="(segment, s) in Story"
                                :key="s"
                                :story="segment"
                                :index="s"
                                :mobile="platform.mobile"
                                :totalYears="Story.length"
                            />

                            <div class="copy section">
                                <p>Thank you for reading my story.</p>
                            </div>
                            <div class="section">
                                <img class="icon m-align-r" src="@/assets/Images/Signature.png" alt="Signature" title="Signature" width="150" height="54"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Template/Header.vue";
import Timespan from "@/components/Story/Timespan.vue";
import { viewModel } from "@/models";
import Story from "@/assets/JS/Data/Story.json";
import { MASTER } from "@/assets/JS/Master.js";

export default {
    name: "StoryView",
    props: { ...viewModel.props },
    components: {
        Header,
        Timespan
    },
    data: () => ({
        ...viewModel.data,
        Story
    }),
    mounted: function() { this.platform.mobile = MASTER.Platform._mobile; },
    emits: [ ...viewModel.emits ]
};
</script>